import Modal2 from "../components/Modal";
import {Modal} from "@mantine/core";
import Button from "../components/Button";
import React, {useState, useMemo, useEffect} from "react";
import alertIcon from '../assets/icons/modal-alert.svg'
import closeIcon from '../assets/icons/close-icon.svg'
import '../styles/pages/site-registration.css';
import {Textarea} from "@mantine/core";
import Select from '../components/Select';
import MantinePagination from '../components/MantinePagination';
import MantineSelectBox from '../components/MantineSelectBox';
import List from '../components/List';
import ResetButton from '../components/ResetButton';
import {apiRequest, nfcRequest} from "../utils/api";
import {useDaumPostcodePopup} from "react-daum-postcode";
import MantineDatePicker from "../components/MantineDatePicker";
import dayjs from "dayjs";
import Alert from '../components/Alert';
import QRCode from "qrcode";
import filterIcon from '../assets/icons/filter-icon.svg';
import ToggleButton from '../components/ToggleButton';

const SiteRegistration = () => {
    const headers = ['일시', '태그NO', '사업자명', '상태', '보기',];
    const statusOptions = [{value: '', label: '전체'}, {value: 'Y', label: '활성화'}, {value: 'N', label: '비활성화'}];
    const countOptions = [{value: '10', label: '10개'}, {value: '20', label: '20개'}, {
        value: '50',
        label: '50개'
    }, {value: '100', label: '100개'},];
    const siteListColumnWidths = ['15%', '30%', '25%', '15%', '15%'];
    const defaultStoreForm = {
        ID: '',
        TAGNUM: '',
        NAME: '',
        CODE: '',
        ADDR: '',
        DETAIL_ADDR: '',
        PHONE: '',
        NOTICE: '',
        STATE: 'Y',
        CHECKLIST: [] // 점검사항들
    };
    const [storeForm, setStoreForm] = useState(defaultStoreForm);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const open = useDaumPostcodePopup();
    const [storeList, setStoreList] = useState([]);
    const [rawStoreList, setRawStoreList] = useState([]);
    const [modalType, setModalType] = useState(null);
    const [modalAction, setModalAction] = useState(() => () => {});

    const [startDate, setStartDate] = useState(dayjs().subtract(7, 'day').format('YYYY-MM-DD'));
    const [endDate, setEndDate] = useState(dayjs().format('YYYY-MM-DD'));
    const [statusFilter, setStatusFilter] = useState('');
    const [storeName, setStoreName] = useState('');
    const [alertOpen, setAlertOpen] = useState({isOpen: false, message: ''});
    const [nfcTagId, setNfcTagId] = useState('');
    const [writeModalOpen, setWriteModalOpen] = useState(false);
    const [mobileFilterModalOpen, setMobileFilterModalOpen] = useState(false);

    const [checklistItems, setChecklistItems] = useState([
        {ITEM: ''},
        {ITEM: ''},
        {ITEM: ''},
    ]);

    const [tagNum, setTagNum] = useState('');

    const pageData = useMemo(() => {
        const startIndex = (currentPage - 1) * itemsPerPage;
        const endIndex = startIndex + itemsPerPage;
        return storeList.slice(startIndex, endIndex);
    }, [currentPage, itemsPerPage, storeList]);

    const totalPages = Math.ceil(storeList.length / itemsPerPage);

    useEffect(() => {
        fetchStoreList();
    }, []);

    const fetchLatestTag = async () => {
        try {
            const res = await nfcRequest('/nfc/latest', 'GET');
            console.log("서버 응답:", res);

            const tagnum = res?.tagnum || res?.data?.tagnum;

            if (tagnum) {
                setTagNum(tagnum);
                setStoreForm(prev => ({ ...prev, TAGNUM: tagnum }));
                alert(`인식된 태그 가져오기 성공!: ${tagnum}`);
            } else {
                alert('NFC 태그가 감지되지 않았습니다. 태그를 리더기에 인식시켜주세요.');
            }
        } catch (err) {
            console.error('태그 인식 실패:', err);
            alert('NFC 리더기 연결 또는 태그 인식에 실패했습니다.');
        }
    };

    const handleChange = (field, value) => {
        if (field === 'PHONE') {
            let numbers = value.replace(/[^0-9]/g, '');
            if (numbers.length > 11) {
                numbers = numbers.slice(0, 11);
            }
            let formatted = numbers;
            if (numbers.length > 3 && numbers.length <= 7) {
                formatted = numbers.slice(0, 3) + '-' + numbers.slice(3);
            } else if (numbers.length > 7) {
                formatted = numbers.slice(0, 3) + '-' + numbers.slice(3, 7) + '-' + numbers.slice(7);
            }
            setStoreForm(prev => ({...prev, [field]: formatted}));
        } else {
            setStoreForm(prev => ({...prev, [field]: value}));
        }
    };

    //사업장 추가
    const handleAddStore = async () => {

        if(!storeForm.TAGNUM){
            alert("턔그NO는 필수입니다.");
            return ;
        }
        try {
            const res = await apiRequest('/addStore', 'POST', {...storeForm, CHECKLIST: checklistItems});
            if (res.success) {
                alert("사업장이 추가되었습니다.");
                fetchStoreList();
                handleReset();
            } else {
                alert("추가 실패");
            }
        } catch (err) {
            console.error(err);
            alert("에러 발생");
        }
    };

    //사업장 조회
    const fetchStoreList = async () => {
        try {
            const res = await apiRequest('/selectStore', 'POST', {
                startDate,
                endDate,
                status: statusFilter,
                storeName,
            });

            const refinedData = res.map(store => {
                return {
                    REG_DTM: store.REG_DTM?.substring(0, 10),
                    TAGNUM: store.TAGNUM,
                    NAME: store.NAME,
                    STATE: store.STATE === 'Y' ? '활성화' : '비활성화',
                    _fullStore: store,
                    VIEW: null
                };
            });

            const finalData = refinedData.map(store => ({
                ...store,
                VIEW: <Button style={{background: '#F9F9F9', color: '#3d3d3d', padding: '5px 20px'}}
                              onClick={() => handleView(store._fullStore)}>보기</Button>
            }));

            setStoreList(finalData);
            setRawStoreList(res); // 필요하면 전체 리스트도 저장
        } catch (err) {
            console.error("현장 리스트 불러오기 실패", err);
        }
    };

    //사업장 수정
    const handleUpdateStore = async () => {
        try {
            const dataToSend = {
                ...storeForm,
                CHECKLIST: checklistItems
            };

            const res = await apiRequest('/updateStore', 'POST', dataToSend);
            if (res.success) {
                alert("수정이 완료되었습니다.");
                fetchStoreList();
                handleReset();
            } else {
                alert("수정 실패");
            }
        } catch (err) {
            console.error("수정 실패", err);
            alert("에러 발생");
        }
    };

    //사업장 삭제
    const handleDeleteStore = async () => {
        if (!storeForm.ID) {
            alert("삭제할 항목이 없습니다.");
            return;
        }

        try {
            const res = await apiRequest('/deleteStore', 'POST', {ID: storeForm.ID});

            if (res.success) {
                alert("삭제 완료");
                fetchStoreList();
                handleReset();
                handleModalClose();
            } else {
                alert("삭제 실패");
            }
        } catch (err) {
            console.error("삭제 실패", err);
            alert("에러 발생");
        }
    };


    const handleView = (store) => {

        setStoreForm({
            ID: store.ID,
            TAGNUM: store.TAGNUM,
            NAME: store.NAME,
            CODE: store.CODE,
            ADDR: store.ADDR,
            DETAIL_ADDR: store.DETAIL_ADDR,
            PHONE: store.PHONE,
            NOTICE: store.NOTICE,
            STATE: store.STATE,
        });

        setChecklistItems(store.CHECKLIST); // 점검 항목 세팅
    };

    const handleSearchAddress = () => {
        open({onComplete: handleComplete});
    };

    const handleModalOpen = () => {
        setIsModalOpen(true);
    };

    const handleModalClose = () => {
        setIsModalOpen(false);
    };

    const showAlert = (message) => {
        setAlertOpen({isOpen: true, message});
    };
    const closeAlert = () => {
        setAlertOpen({isOpen: false, message: ''});
    };

    const handleReset = () => {
        setStoreForm(defaultStoreForm);
        setChecklistItems([
            {ITEM: ''},
            {ITEM: ''},
            {ITEM: ''},
        ]);
    };

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleItemsPerPageChange = (value) => {
        setItemsPerPage(parseInt(value));
        setCurrentPage(1);
    };

    const handleComplete = (data) => {
        const fullAddress = data.roadAddress || data.jibunAddress;
        setStoreForm(prev => ({
            ...prev,
            ADDR: fullAddress,
            CODE: data.zonecode
        }));
    };

    const handleAddChecklistItem = () => {
        if (checklistItems.length >= 8) {
            showAlert('점검사항은 최대 8개까지 추가할 수 있습니다.');
            return;
        }
        setChecklistItems(prev => [...prev, { ITEM: '' }]);
    };

    const readNFC = async () => {
        try {
            if ("NDEFReader" in window) {

                // eslint-disable-next-line no-undef
                const ndef = new NDEFReader();
                await ndef.scan();

                showAlert("NFC 태그를 스캔하세요.");

                ndef.onreading = event => {
                    const serial = event.serialNumber;
                    setNfcTagId(serial);
                    setStoreForm(prev => ({...prev, TAGNUM: serial})); // 자동 세팅
                    showAlert(`태그 인식 완료: ${serial}`);
                };
            } else {
                showAlert("브라우저가 NFC를 지원하지 않습니다.");
            }
        } catch (error) {
            showAlert("NFC 인식 오류");
            console.error("NFC 읽기 오류:", error);
        }
    };

    const saveQRcode = async () => {
        if (!storeForm.TAGNUM) {
            alert("TAGNUM이 없습니다.");
            return;
        }

        const qrUrl = `https://ddsecurity.co.kr/nfc?tagnum=${encodeURIComponent(storeForm.TAGNUM)}`;

        try {
            const canvas = document.createElement("canvas");
            await QRCode.toCanvas(canvas, qrUrl, {errorCorrectionLevel: 'H'});

            const link = document.createElement("a");
            link.href = canvas.toDataURL("image/png");
            link.download = `TAG_${storeForm.TAGNUM}_QR.png`;
            link.click();
        } catch (err) {
            console.error("QR 코드 생성 실패:", err);
        }
    };

    const handleMobileFilterSearch = () => {
        fetchStoreList();
        setMobileFilterModalOpen(false);
    };

    return (
        <div className="page-content">

            <div className="left-section">
                <div className="reset-button-wrapper">
                    <ResetButton onClick={handleReset} size="small"/>
                </div>
                <div className="small-margin-section"/>

                <div className="left-top-section">
                    <div className="input-wrapper gmarket-font">
                        <p>태그NO</p>
                        <input className="gray-input" value={storeForm.TAGNUM}
                               onChange={e => handleChange('TAGNUM', e.target.value)}/>
                    </div>
                    <div className="input-wrapper gmarket-font">
                        <p>사업장명</p>
                        <input className="gray-input" value={storeForm.NAME}
                               onChange={e => handleChange('NAME', e.target.value)}/>
                    </div>
                    <div className="input-wrapper gmarket-font">
                        <p>주소</p>
                        <input
                            className='gray-input'
                            type="text"
                            readOnly
                            value={storeForm.CODE || ''}
                            placeholder="우편번호"
                        />
                        <Button className="confirm-button" onClick={handleSearchAddress}>주소 검색</Button>
                    </div>
                    <div className="input-wrapper gmarket-font">
                        <p></p>
                        <input
                            className='gray-input'
                            type="text"
                            name="ADDR"
                            readOnly
                            value={storeForm.ADDR || ''}
                            placeholder="주소"
                        />
                    </div>
                    <div className="input-wrapper gmarket-font">
                        <p></p>
                        <input
                            className='gray-input'
                            type="text"
                            name="DETAIL_ADDR"
                            value={storeForm.DETAIL_ADDR}
                            onChange={(e) => handleChange('DETAIL_ADDR', e.target.value)}
                            placeholder="상세주소"
                        />
                    </div>
                    <div>
                    </div>
                    <div className="input-wrapper gmarket-font">
                        <p>연락처</p>
                        <input className="gray-input"
                               value={storeForm.PHONE}
                               onChange={e => handleChange('PHONE', e.target.value)}
                               maxLength={13}/>
                    </div>
                    <div className="title-text gmarket-font">
                        <p>공지사항</p>
                        <Textarea
                            value={storeForm.NOTICE}
                            onChange={e => handleChange('NOTICE', e.target.value)}
                            styles={{
                                input: {
                                    borderRadius: '10px',
                                    background: '#F9F9F9',
                                    border: 'none',
                                    fontSize: '15px',
                                    height: '100px',
                                }
                            }}
                        />
                    </div>
                </div>

                <div className="title-text">
                    <p>점검사항</p>
                    {checklistItems.map((item, index) => (
                        <div key={index} className="input-wrapper gmarket-font">
                            <div style={{position: 'relative'}}>
                                <input
                                    className="inspection-input"
                                    placeholder="점검 항목"
                                    value={item.ITEM}
                                    onChange={e => {
                                        const newList = [...checklistItems];
                                        newList[index].ITEM = e.target.value;
                                        setChecklistItems(newList);
                                    }}
                                />
                                <img
                                    src={closeIcon}
                                    alt="삭제"
                                    onClick={() => {
                                        const newList = checklistItems.filter((_, i) => i !== index);
                                        setChecklistItems(newList);
                                    }}
                                    style={{
                                        position: 'absolute',
                                        right: '8px',
                                        top: '50%',
                                        transform: 'translateY(-50%)',
                                        width: '16px',
                                        height: '16px',
                                        cursor: 'pointer'
                                    }}
                                />
                            </div>
                        </div>
                    ))}
                    <Button className="add-button" onClick={handleAddChecklistItem}>점검사항 추가하기</Button>
                </div>

                <div className="small-margin-section"/>

                <div className="toggle-section">
                    <p className="title-text">승인상태</p>
                    <ToggleButton
                        value={storeForm.STATE}
                        onChange={(value) => handleChange('STATE', value)}
                        options={[
                            {value: 'Y', label: '활성화'},
                            {value: 'N', label: '비활성화'}
                        ]}
                    />
                </div>

                <div className="small-margin-section"/>

                <div className="button-wrapper">
                    {!storeForm.ID && (
                        <Button
                            className="bottom-button"
                            onClick={() => {
                                setModalType("add");
                                setModalAction(() => handleAddStore);
                                setIsModalOpen(true);
                            }}
                        >저장</Button>
                    )}

                    {storeForm.ID && (
                        <Button
                            className="bottom-button"
                            onClick={() => {
                                setModalType("update");
                                setModalAction(() => handleUpdateStore);
                                setIsModalOpen(true);
                            }}
                        >수정</Button>
                    )}

                    <Button
                        className="bottom-button"
                        onClick={() => {
                            setModalType("delete");
                            setModalAction(() => handleDeleteStore);
                            setIsModalOpen(true);
                        }}
                    >삭제</Button>

                </div>

                <div className="margin-bottom-section"/>
            </div>

            <div className="right-section">
                <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    marginBottom: '16px'
                }}>
                    <p className="title-text gmarket-font">현장정보</p>
                    <img
                        src={filterIcon}
                        alt="필터아이콘"
                        className="filter-icon"
                        onClick={() => setMobileFilterModalOpen(true)}
                    />
                </div>

                <div className="top-section desktop-filter">
                    <div className="filter-section2">
                        <div className="date-filter-wrapper">
                            <MantineDatePicker value={startDate} onChange={setStartDate}/>
                            <span style={{margin: '10px 8px'}}>-</span>
                            <MantineDatePicker value={endDate} onChange={setEndDate}/>
                        </div>
                        <MantineSelectBox
                            style={{width: '100px'}}
                            value={statusFilter}
                            onChange={setStatusFilter}
                            withinPortal={false}
                            options={[
                                {value: '', label: '전체'},
                                {value: 'Y', label: '활성화'},
                                {value: 'N', label: '비활성화'},
                            ]}
                        >
                            상태
                        </MantineSelectBox>
                        <input
                            placeholder="사업장 검색"
                            value={storeName}
                            onChange={(e) => setStoreName(e.target.value)}
                            className="site-search-input"
                            style={{paddingLeft: '20px', width: '145px'}}
                        />
                    </div>

                    <Button width="100px" height="50px" onClick={fetchStoreList}>찾기</Button>
                </div>
                <div>
                    <div className="total-count-text">총 사업장 : {storeList.length}곳</div>
                </div>
                <div className="list-wrapper">
                    <List headers={headers} data={pageData} showCheckbox={false} columnWidths={siteListColumnWidths}/>
                </div>

                <div className="middle-section">
                    <div></div>
                    <MantinePagination
                        total={totalPages}
                        value={currentPage}
                        onChange={handlePageChange}
                    />
                    <div className="select-wrapper">
                        <Select options={countOptions} width="107px" height="42px" value={itemsPerPage.toString()}
                                onChange={handleItemsPerPageChange}>
                        </Select>
                    </div>
                </div>

                <div className="site-qr-wrapper">
                    <button className='site-qr-button' onClick={() => {
                        if ("NDEFReader" in window) {
                            readNFC(); // 모바일용
                        } else {
                            fetchLatestTag(); // PC용 리더기
                        }
                    }}>
                        태그 스캔
                    </button>
                    <button className='site-nfc-button' onClick={saveQRcode}>
                        QR코드 저장
                    </button>
                </div>
            </div>

            <Modal2
                icon={alertIcon}
                // title={
                //     modalType === "delete"
                //         ? "삭제하시겠습니까?"
                //         : modalType === "update"
                //             ? "수정하시겠습니까?"
                //             : "저장하시겠습니까?"
                // }
                children={
                    <p>
                        {modalType === "delete"
                            ? "삭제된 데이터는 복구할 수 없습니다. 정말로 삭제하시겠습니까?"
                            : modalType === "update"
                                ? "변경된 내용을 저장하시겠습니까?"
                                : "입력한 데이터를 저장하시겠습니까?"}
                    </p>
                }
                isOpen={isModalOpen}
                primaryButton={{
                    text: "취소하기",
                    onClick: handleModalClose
                }}
                secondaryButton={{
                    text: modalType === "delete" ? "삭제하기" : "확인",
                    onClick: () => {
                        modalAction(); // 저장/수정/삭제 실행
                        handleModalClose();
                    }
                }}
                shouldCloseOnBackgroundClick={true}
                onBackgroundClick={handleModalClose}
            />

            {mobileFilterModalOpen && (
                <Modal
                    opened={mobileFilterModalOpen}
                    onClose={() => setMobileFilterModalOpen(false)}
                    zIndex={9999}
                    centered={false}
                    size="md"
                    withinPortal={true}
                    styles={{
                        content: {
                            position: 'fixed',
                            bottom: 0,
                            left: 0,
                            right: 0,
                            margin: 0,
                            borderRadius: '20px 20px 0 0',
                            transform: 'translateY(0)',
                            maxHeight: '100vh',
                            overflow: 'hidden',
                            animation: mobileFilterModalOpen ? 'slideUp 0.4s cubic-bezier(0.25, 0.8, 0.25, 1)' : 'slideDown 0.3s ease-in'
                        }, body: {padding: '20px', maxHeight: '100vh', overflowY: 'auto'}, header: {display: 'none'}
                    }} transitionProps={{transition: 'fade', duration: 0}}>
                    <div>
                        <div>
                            <p className='gmarket-font'>시작일</p>
                            <div>
                                <MantineDatePicker
                                    value={startDate}
                                    onChange={setStartDate}
                                    className="mobile-date-picker"
                                    comboboxProps={{
                                        withinPortal: false,
                                        zIndex: 10002,
                                        position: 'bottom'
                                    }}
                                    popoverProps={{
                                        withinPortal: false,
                                        zIndex: 10002,
                                        position: 'bottom',
                                        styles: {dropdown: {width: '350px', maxWidth: '350px'}}
                                    }}
                                    styles={{levelsGroup: {display: 'flex', justifyContent: 'center', width: '100%'}}}
                                />
                                <p className='gmarket-font'>종료일</p>
                                <MantineDatePicker
                                    value={endDate}
                                    onChange={setEndDate}
                                    className="mobile-date-picker"
                                    comboboxProps={{
                                        withinPortal: false,
                                        zIndex: 10002,
                                        position: 'bottom'
                                    }}
                                    popoverProps={{
                                        withinPortal: false,
                                        zIndex: 10002,
                                        position: 'bottom',
                                        styles: {dropdown: {width: '350px', maxWidth: '350px'}}
                                    }}
                                    styles={{levelsGroup: {display: 'flex', justifyContent: 'center', width: '100%'}}}
                                />
                            </div>
                        </div>

                        <div>
                            <p className='gmarket-font'>상태</p>
                            <MantineSelectBox
                                style={{width: '100%'}}
                                value={statusFilter}
                                onChange={setStatusFilter}
                                comboboxProps={{
                                    withinPortal: false,
                                    zIndex: 10002,
                                    position: 'bottom'
                                }}
                                options={[
                                    {value: '', label: '전체'},
                                    {value: 'Y', label: '활성화'},
                                    {value: 'N', label: '비활성화'},
                                ]}
                            />
                        </div>

                        <div style={{marginBottom: '20px'}}>
                            <p className='gmarket-font'>사업장 검색</p>
                            <input
                                placeholder="사업장 검색"
                                value={storeName}
                                onChange={(e) => setStoreName(e.target.value)}
                                style={{
                                    paddingLeft: '20px',
                                    width: '100%',
                                    height: '50px',
                                    borderRadius: '3px',
                                    border: '1px solid #ABABAB',
                                    padding: '12px 12px 12px 40px',
                                    color: '#333'
                                }}
                            />
                        </div>

                        <div style={{display: 'flex', gap: '10px'}}>
                            <Button
                                onClick={() => setMobileFilterModalOpen(false)}
                                style={{
                                    flex: 1,
                                    height: '50px',
                                    backgroundColor: '#f4f5f6',
                                    color: '#333',
                                    borderRadius: '10px'
                                }}
                            >
                                취소
                            </Button>
                            <Button
                                onClick={handleMobileFilterSearch}
                                style={{
                                    flex: 1,
                                    height: '50px',
                                    borderRadius: '10px'
                                }}
                            >
                                찾기
                            </Button>
                        </div>
                    </div>
                </Modal>
            )}
            <Alert
                isOpen={alertOpen.isOpen}
                message={alertOpen.message}
                onConfirm={closeAlert}
            />
        </div>
    );
};

export default SiteRegistration;
